import { styled } from 'linaria/react';

export const StepHeaderTextDescription = styled('span')`
  font-weight: 400;
  margin-left: 10px;
`